import { Children, memo, useState } from "react"
import { Box, Button, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

import { theme } from "../../../../utils"
import TransMsg from "../../transMessage";
import VendorStaticData from "../../../../assets/data/vendorList";
import { useSnackbar } from "../../../../contexts";
import {styles, sortVendorData} from "./aiToolsSection-helpers";
import {RedirectDialog} from "../../../../components";


interface IAIToolsProps {
    data: any[]
}


const AIToolsSection = (props: IAIToolsProps) => {
    const { data } = props

    const navigate = useNavigate()
    const { t } = useTranslation();
    const { showSnackbar } = useSnackbar();
    const vendorListData = data?.length > 0 ? sortVendorData(data) : []

    const [openRedirectDialog, setOpenRedirectDialog] = useState<boolean>(false)
    const [selectedVendor, setSelectedVendor] = useState<any>({})

    const onSelectVendorItem = (itemData: any) => {
        // @ts-ignore
        amplitude.logEvent(`user clicked ${itemData?.title} vendor`)
        setSelectedVendor(itemData)

        // handle redirection modal if checked already
        const getCheckedVendors = localStorage.getItem("checkedVendors")
        const checkedVendorsList:any[] = getCheckedVendors ? JSON.parse(getCheckedVendors) : []
        const isModalShown = checkedVendorsList?.includes(itemData?.vendorId)
        setOpenRedirectDialog(!isModalShown)
        if(isModalShown && itemData?.redirectURL){
            const url = itemData?.redirectURL
            if (url) {
                window.open(`https://${url}`, '_blank', 'noopener,noreferrer');
            }
            else {
                showSnackbar("redirect uri is not available!", "error")
            }
        }
    }

    const onSelectMore = (itemData: any) => {
        // @ts-ignore
        amplitude.logEvent(`user clicked learn more for ${itemData?.title} vendor`)
        const vendorItemIndex = VendorStaticData?.data.findIndex((item: any) => item?.vendorName === itemData?.title)
        navigate(`/vendor-details?routePath=${itemData?.title}&vendor=${itemData?.name}&index=${vendorItemIndex}`)
    }
    return (
        <Box mt={"200px"} gap={'24px'} mb={"40px"} flex={1}>
            <Typography
                sx={{ ...theme.typography.opticianBodyRegular, color: "#1C1B1A", mt: "4rem", fontSize: "32px", mb:'30px' }}>
                {t(TransMsg.JOIN_AI_CAPTION)}
            </Typography>

            <Typography
                sx={{ ...theme.typography.poppinsBodyRegular, color: "#1E1E22", fontSize: "18px", px:"31px" }}>
                <Trans i18nKey={TransMsg.TRADITIONAL_SCANS} components={{ br: <br /> }} />
            </Typography>

            <Box display={"flex"} flexWrap={"wrap"} gap={"24px"} mt={"10px"} justifyContent={"center"}>
                {vendorListData?.length > 0 && Children.toArray(vendorListData.map((item: any, index: number) => {
                    const logoSvg = item?.card_logo ? require(`../../../../assets/images/svgs/${item?.card_logo}`) : ""
                    return (
                        <Box sx={{...styles.vendorCard}} display={"flex"} flexDirection={"column"} key={index + 1}>
                            <Box sx={{ py: "28px" }}>
                                <img src={logoSvg} style={{ width: "143px", height: "43px" }} alt={`vendor-item-${index}`} />
                            </Box>
                            <Box flex={1} display={"flex"} flexDirection={"column"} sx={styles.descriptionBox} justifyContent={"center"}>
                                <Box flex={1}>
                                    <Typography
                                        sx={{ ...theme.typography.poppinsBodyMedium, fontSize: "18px", fontWeight:600, lineHeight:'100%', letterSpacing:'0%', color: "#1E1E22" }}>
                                        {item?.title}
                                    </Typography>
                                    <Typography
                                        sx={{...styles.cardDescription, mb:'15px'}}>
                                        {item?.card_description}
                                    </Typography>
                                </Box>
                                <Box display={"flex"} gap={'1rem'} justifyContent={"center"}>
                                    <Button
                                        variant='outlined'
                                        onClick={() => onSelectVendorItem(item)}
                                        sx={[styles.rowAlignBtnWrapper, { borderColor:"#404144"}]}>
                                        <Typography
                                            sx={{ ...theme.typography.components.montseratButtonOutlinedLabel }}>
                                            {t(TransMsg.LAUNCH_TOOL_LABEL)}
                                        </Typography>
                                    </Button>
                                    <Button
                                        variant='contained'
                                        onClick={() => onSelectMore(item)}
                                        sx={styles.rowAlignBtnWrapper}>
                                        <Typography
                                            sx={{ ...theme.typography.components.montseratButtonContainedLabel }}>
                                            {t(TransMsg.LEARN_MORE_LABEL)}
                                        </Typography>
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    )
                }))}
            </Box>
            <Box display={"flex"} justifyContent={"center"} mt={"10px"} width={"100%"}>
                <Typography
                    sx={{ ...theme.typography.poppinsBodyLight, color: "#1E1E22", mt: "1rem", fontStyle:"italic", fontSize:"15px", maxWidth: "1076px", width: "100%" , }}>
                <Trans
                        i18nKey={t(TransMsg.JOIN_AI_FOOTER_DESCRIPTION)}
                        components={{ br: <br /> }} />
                </Typography>
            </Box>
            <RedirectDialog
                showDialog={openRedirectDialog}
                vendorItem={selectedVendor}
                onCloseRedirectDialog={() => setOpenRedirectDialog(false)} />
        </Box>
    )
}

export default memo(AIToolsSection)